module.exports = __webpack_public_path__ + "i18n/ru_e72adc20da66df9b4da4216793490ffd.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 153